<template>
    <div class="layout-wrapper">
        <div class="container-fluid">
            <div class="col-12">
                <div class="card shadow">
                    <div class="card-header  bg-accent-grad glow-accent text-center">
                        <h3 class="text-white">مدیریت محل هزینه و دریافت</h3>

                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="card-header admin-header w-100">

                                <h5 class="text-accent-light">محل هزینه/دریافت</h5>
                                <!--<h5 class="text-accent-light" v-if="showArchive">(آرشیو شده)</h5>-->
                                <div class="text-left">
                                    <!--<button class="btn btn-link text-accent-lightt"-->
                                    <!--@click="onArchiveClicked()">-->
                                    <!--<i class="fa fa-eye" v-if="showArchive" title="عدم نمایش آرشیو ها"></i>-->
                                    <!--<i class="fa fa-eye-slash" v-else title="نمایش آرشیو ها"></i>-->
                                    <!--</button>-->
                                    <button class="btn btn-link text-accent-light"
                                            @click="onAddpayReciptForClicked()"><i class="fa fa-plus"></i>
                                    </button>
                                </div>
                            </div>

                            <div class="col-12 input-group round mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">جستجو</span>
                                </div>
                                <input class="form-control" v-model="search" @input="searching()"
                                       placeholder="حداقل 2 کاراکتر از نام محل هزینه/دریافت را وارد کنید">
                            </div>
                            <div class="table-responsive">
                                <div v-if="!isLoading">
                                    <preloader/>
                                </div>
                                <div v-else>
                                    <div v-if="mypayReciptFors.length===0">
                                        <p class="text-center mt-3">هیچ محل هزینه/دریافتی ثبت نشده است. برای ثبت روی
                                            دکمه + کلیک
                                            کنید</p>

                                    </div>
                                    <div v-else>
                                        <table class="table table-hover table-striped mb-3">
                                            <thead>
                                            <tr class="text-center">
                                                <th>نام محل هزینه/دریافت</th>
                                                <th>هزینه/دریافت</th>
                                                <th>وابسته به کاربر</th>
                                                <!--<th>وابسته به مشتری</th>-->
                                                <th>وابسته به قرارداد مشتری</th>
                                                <th>عملیات</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="it in mypayReciptFors" class="text-center">

                                                <td class="text-nowrap">{{it.name}}</td>
                                                <td class="text-nowrap">{{it.payRecipt === false ? 'هزینه' :'دریافت'}}
                                                </td>
                                                <td class="text-nowrap">
                                                    <i class="fa fa-check-square-o" v-if="it.userDependency"></i>
                                                    <i class="fa fa-square-o" v-else></i>
                                                </td>
                                                <!--<td class="text-nowrap">-->
                                                    <!--<i class="fa fa-check-square-o" v-if="it.customerDependency"></i>-->
                                                    <!--<i class="fa fa-square-o" v-else></i>-->
                                                <!--</td>-->
                                                <td class="text-nowrap">
                                                    <i class="fa fa-check-square-o" v-if="it.customerBuyDependency"></i>
                                                    <i class="fa fa-square-o" v-else></i>
                                                </td>
                                                <td class="text-center text-nowrap"><i
                                                        class="fa fa-pencil-square-o px-3 clickable"
                                                        style="font-size: larger"
                                                        @click="editItem(it)"
                                                        title="ویرایش آیتم"></i>
                                                    | <i class="fa fa-trash-o px-3 clickable"
                                                         style="font-size: larger"
                                                         @click="deleteItem(it)"
                                                         title="حذف آیتم"></i>

                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--///////////////////////////////////////////////////////////////////////////////////////////////////-->
            <modal show="false" ref="insertModal">
                <div class="row p-lg-3 p-3">
                    <div class="col-12 text-center">
                        <h1 v-if="payReciptForMode === 'create'">ثبت محل هزینه/دریافت</h1>
                        <h1 v-else>ویرایش محل هزینه/دریافت</h1>
                    </div>
                    <div class="col-lg-2 mb-4"></div>
                    <div class="col-lg-4 mb-4">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">نام محل هزینه/دریافت</span>
                            </div>
                            <input class="form-control" v-model="payReciptForModel.name">
                        </div>
                    </div>
                    <div class="col-lg-4 mb-2">
                        <div class="input-group round">
                            <div class="input-group-prepend">
                                <span class="input-group-text">هزینه یا دریافت</span>
                            </div>
                            <vs-select @onSearch="onDropDownFocused" @onSearchBlurred="onDropDownBlurred"
                                       ref="evidence"
                                       :data="payRecipt"
                                       :mode="'create'"
                                       :selected-val="selectedPayRec"
                                       :header="{multiple: false, label: 'title'}"
                                       aria-placeholder="هزینه یا دریافت"
                                       @onChange="onpayReciptChange"></vs-select>
                        </div>
                    </div>

                    <div class="col-12">
                        <div class="row">

                            <div class="col-3 mt-3"></div>
                            <div class="col-5 mt-3">
                                <h5>آیا این نوع از هزینه/دریافت به کاربر وابسته است</h5>
                            </div>
                            <div class="col-1 text-left  mt-3">
                                <toggle-button id="changed-font" class="m-0 ml-5"
                                               :color="{checked: '#297bf6', unchecked: '#90a4ae'}"
                                               :value="payReciptForModel.userDependency"
                                               :sync="true" @change="onuserDependencyChange($event)"/>
                            </div>
                        </div>
                    </div>

                    <!--<div class="col-12">-->
                        <!--<div class="row">-->

                            <!--<div class="col-3 mt-3"></div>-->
                            <!--<div class="col-5 mt-3">-->
                                <!--<h5>آیا این نوع از هزینه/دریافت به مشتری وابسته است</h5>-->
                            <!--</div>-->
                            <!--<div class="col-1 text-left  mt-3">-->
                                <!--<toggle-button id="changed-font2" class="m-0 ml-5"-->
                                               <!--:color="{checked: '#297bf6', unchecked: '#90a4ae'}"-->
                                               <!--:value="payReciptForModel.customerDependency"-->
                                               <!--:sync="true" @change="oncustomerDependencyChange($event)"/>-->
                            <!--</div>-->
                        <!--</div>-->
                    <!--</div>-->

                    <div class="col-12">
                        <div class="row">

                            <div class="col-3 mt-3"></div>
                            <div class="col-5 mt-3">
                                <h5>آیا این نوع از هزینه/دریافت به قرارداد مشتری وابسته است</h5>
                            </div>
                            <div class="col-1 text-left  mt-3">
                                <toggle-button id="changed-font3" class="m-0 ml-5"
                                               :color="{checked: '#297bf6', unchecked: '#90a4ae'}"
                                               :value="payReciptForModel.customerBuyDependency"
                                               :sync="true" @change="oncustomerBuyDependencyChange($event)"/>
                            </div>
                        </div>
                    </div>


                    <div class="col-lg-6 offset-lg-3 text-center">
                        <button class="btn btn-success btn-round clickable mt-3" :disabled="isSending"
                                @click="updatepayReciptFor" v-if="payReciptForMode=='edit'">ویرایش محل هزینه/دریافت
                        </button>
                        <button class="btn btn-success btn-round clickable mt-3" :disabled="isSending"
                                @click="createpayReciptFor" v-else>ثبت محل هزینه/دریافت
                        </button>
                        <button class="btn btn-primary btn-round clickable mt-3 mx-3"
                                @click="cancelpayReciptFor">انصراف
                        </button>
                    </div>
                </div>
            </modal>
            <!--////////////-->

        </div>
    </div>
</template>

<script>
    import BaseService from "../../_framework/api/BaseService";
    import DatePicker from '../../_framework/vue-persian-datetime-picker/VuePersianDatetimePicker.vue';
    import VsSelect from "../../_framework/VsSelect";
    import Utils from "../../_framework/utils/Utils";
    import Moment from 'moment-jalali';
    import Constants from "../../_framework/Constants";

    export default {
        name: "payReciptFor",
        components: {VsSelect, DatePicker},
        data() {
            return {

                showArchive: false,
                isSending: false,
                isLoading: false,
                mypayReciptFors: [],

                payReciptForMode: "",
                payReciptForModel: {
                    id: 0,
                    name: "",
                    userDependency: false,
                    customerDependency: false,
                    customerBuyDependency: false,
                },
                search: "",

                payRecipt: [
                    {
                        value: "0",
                        title: "هزینه"
                    },
                    {
                        value: "1",
                        title: "دریافت"
                    }
                ],
                newImageCliked: false,
                showVersions: false,
                selectedPayRec: {},


            }
        },
        mounted() {
            this.getMypayReciptFors();
        },
        methods: {

            onArchiveClicked() {
                if (this.showArchive) {
                    this.showArchive = false;
                    this.getMypayReciptFors();
                } else {
                    this.showArchive = true;
                    new BaseService("payReciptFor", "/GetArchivepayReciptFor").getList().then(response => {
                        this.mypayReciptFors = response.data;
                        this.isLoading = true;
                    }).catch(error => {
                        Utils.handleErrorWithNotification(error.data, this.$noty);
                    });
                }
            },
            onEndContractChange(e) {
                const m = {
                    contractId: this.payReciptForModel.id,
                    ending: e.value
                };
                new BaseService("payReciptFor", '/EndpayReciptFor').update(m).then(response => {
                    if (e.value) {
                        this.$noty.success("محل هزینه/دریافت با موفقیت آرشیو شد و دیگر نشان داده نمیشود");

                    } else {
                        this.$noty.success("محل هزینه/دریافت با موفقیت بازیابی شد و نشان داده میشود");
                    }
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
                this.payReciptForModel.endCorporation = e.value;

            },
            onAddpayReciptForClicked() {
                this.payReciptForModel = {
                    id: 0,
                    name: "",
                    userDependency: false,
                    customerDependency: false,
                    customerBuyDependency: false,
                };
                this.payReciptForMode = "create";
                this.selectedPayRec = {};
                this.$refs.insertModal.showModal();
            },
            getMypayReciptFors() {
                new BaseService("payReciptFor", "/GetpayReciptFor").getList().then(response => {
                    this.mypayReciptFors = response.data;
                    this.isLoading = true;
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                });
            },
            editItem(item) {
                this.payReciptForModel = item;
                // console.log(item)
                // console.log(this.payReciptForModel.userDependency)
                // console.log(this.payReciptForModel.customerBuyDependency)
                this.payReciptForMode = "edit";
                if (this.payReciptForModel.payRecipt === false) {
                    this.selectedPayRec.value = 0;
                    this.selectedPayRec.title = "هزینه";

                } else {
                    this.selectedPayRec.value = 1;
                    this.selectedPayRec.title = "دریافت";
                }
                this.$refs.insertModal.showModal();
            },
            deleteItem(item) {
                if (confirm("آیا از حذف این آیتم اطمینان دارید؟")) {
                    new BaseService("payReciptFor", "DeletepayReciptFor").delete(item.id).then(response => {
                        this.$noty.warning("آیتم با موفقیت حذف شد");
                        this.getMypayReciptFors();
                    }).catch(error => {
                        Utils.handleErrorWithNotification("این آیتم در جای دیگری استفاده شده است، ابتدا موارد وابسته را پاک کنید", this.$noty);
                    })
                }
            },

            updatepayReciptFor() {
                this.isSending = true;
                new BaseService("payReciptFor", "/UpdatepayReciptFor").update(this.payReciptForModel).then(response => {
                    this.$noty.success("محل هزینه/دریافت با موفقیت ویرایش شد");
                    this.isSending = false;
                    this.$refs.insertModal.hideModal();
                    this.getMypayReciptFors();
                }).catch(error => {
                    console.log(error)
                    this.isSending = false;
                    Utils.handleErrorWithNotification(error, this.$noty);
                    this.$refs.insertModal.hideModal();
                    this.getMypayReciptFors();
                });


            },
            createpayReciptFor() {
                this.isSending = true;
                new BaseService("payReciptFor", "/CreatepayReciptFor").create(this.payReciptForModel).then(response => {
                    this.$noty.success("محل هزینه/دریافت با موفقیت ثبت شد");
                    this.$refs.insertModal.hideModal();
                    this.isSending = false;
                    this.getMypayReciptFors();
                }).catch(error => {
                    this.isSending = false;
                    Utils.handleErrorWithNotification(error.data, this.$noty);
                    this.$refs.insertModal.hideModal();
                    this.getMypayReciptFors();
                });

            },
            cancelpayReciptFor() {
                this.$refs.insertModal.hideModal();
                this.getMypayReciptFors();
            },

            searching() {
                if (this.search.length > 2) {
                    this.isLoading = false;
                    new BaseService("payReciptFor", `/SearchpayReciptFor/${this.search}`).getList().then(response => {
                        this.mypayReciptFors = response.data;
                        this.isLoading = true;
                    }).catch(error => {
                        Utils.handleErrorWithNotification(error.data, this.$noty);
                    });
                } else {
                    this.getMypayReciptFors();
                }
            },
            addDocument(it) {
                this.payReciptForDocumentMode = "create";
                this.payReciptForDocumentModel.payReciptForId = it.id;
                this.$refs.addDocModal.showModal();
            },
            editDocument(item) {
                this.payReciptForDocumentMode = "edit";
                this.payReciptForDocumentModel = item;
                this.$refs.addDocModal.showModal();
            },

            onImageChange(e) {
                let files = e.target.files;
                let app = this;
                if (files && files[0]) {
                    this.newImageCliked = true;
                    for (let item of files) {
                        let extention = item.name.slice((item.name.lastIndexOf(".") - 1 >>> 0) + 2);
                        // if (extention === "jpg" || extention === "JPG" ||
                        //     extention === "png" || extention === "PNG" ||
                        //     extention === "JPEG" || extention === "jpeg") {
                        let reader = new FileReader();
                        reader.onload = function (e) {
                            // $("#bannerImg").attr("src", e.target.result);
                            let a = e.target.result;
                            // let img = document.getElementById('docImg');
                            // img.src = e.target.result;
                            app.payReciptForDocumentModel.address = a.substring(a.indexOf(',') + 1, a.length);
                            app.payReciptForDocumentModel.extention = extention;
                            app.payReciptForDocumentModel.newImage = e.target.result;
                        };
                        reader.readAsDataURL(item);
                        // } else {
                        //     alert("لطفا فایل عکس بارگذاری کنید");
                        // }
                    }
                }
            },
            createpayReciptForDocument() {

                this.isSending = true;
                if (this.payReciptForDocumentMode === 'create') {
                    new BaseService("payReciptForDocument", "/CreatepayReciptForDocument").create(this.payReciptForDocumentModel).then(response => {
                        this.$noty.success("مدرک با موفقیت ثبت شد");
                        this.isSending = false;
                        this.$refs.addDocModal.hideModal();
                        this.getMypayReciptFors();
                    }).catch(error => {
                        this.isSending = false;
                        Utils.handleErrorWithNotification("خطا!! لطفا پارامترها را مجددا بررسی کنید", this.$noty);
                        this.$refs.addDocModal.hideModal();
                        this.getMypayReciptFors();
                    });
                } else {
                    new BaseService("payReciptForDocument", "/UpdatepayReciptForDocument").update(this.payReciptForDocumentModel).then(response => {
                        this.$noty.success("مدرک با موفقیت ثبت شد");
                        this.isSending = false;
                        this.$refs.addDocModal.hideModal();
                        this.getMypayReciptFors();
                    }).catch(error => {
                        this.isSending = false;
                        Utils.handleErrorWithNotification("خطا!! لطفا پارامترها را مجددا بررسی کنید", this.$noty);
                        this.$refs.addDocModal.hideModal();
                        this.getMypayReciptFors();
                    });
                }

            },
            canceluserContract() {
                this.$refs.addDocModal.hideModal();
                this.getMypayReciptFors();
            },
            docVersions(it) {
                if (this.showVersions) {
                    this.showVersions = false;

                } else {
                    this.showVersions = true;
                    new BaseService("payReciptForDocument", `/GetTotalpayReciptForDocument/${it.id}`).getList().then(response => {
                        this.payReciptForDocuments = response.data;
                        // this.isLoading = true;
                    }).catch(error => {
                        console.log(error);
                        Utils.handleErrorWithNotification(error.data, this.$noty);
                    });
                    //
                    // var serinum = 1;
                    // this.designDocument = [];
                    // for (let i = 0; i < it.sampleNumber; i++) {
                    //     const a = {
                    //         sampleNumber: serinum,
                    //         id: it.id
                    //     };
                    //     this.designDocument.push(a);
                    //
                    //     serinum = serinum + 1;
                    // }
                }
            },
            thousandSepratorp(a) {
                let amount = this.payReciptForModel.price;
                if (amount !== '' || amount !== undefined || amount !== 0 || amount !== '0' || amount !== null) {
                    this.payReciptForModel.showprice = amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                } else {
                    this.payReciptForModel.showprice = amount;
                }
            },
            thousandSepratord(a) {
                let amount = this.payReciptForModel.discount;
                if (amount !== '' || amount !== undefined || amount !== 0 || amount !== '0' || amount !== null) {
                    this.payReciptForModel.showdisc = amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                } else {
                    this.payReciptForModel.showdisc = amount;
                }
            },
            onpayReciptChange(i) {
                if (i) {
                    if (i.value == 0) {

                        this.payReciptForModel.payRecipt = false;
                    } else if (i.value == 1) {
                        this.payReciptForModel.payRecipt = true;

                    }
                }
            },
            onuserDependencyChange(e) {
                if (e) {
                    this.payReciptForModel.userDependency = e.value;
                }
            },
            oncustomerDependencyChange(e) {
                if (e ) {
                    this.payReciptForModel.customerDependency = e.value;
                }
            },
            oncustomerBuyDependencyChange(e) {
                if (e ) {
                    this.payReciptForModel.customerBuyDependency = e.value;
                }
            },


        }
    }
</script>

<style lang="scss" scoped>
    .profile-image {
        margin: 0 auto 1rem auto;
    }

    .profile-image img {
        max-width: 150px;
        border-radius: 1rem;
        box-shadow: 0 10px 25px -10px rgba(0, 0, 0, 0.25);
    }
</style>